import connectAccount from './connectAccount';
import identity from './identity';
import socials from './socials';

export default { identity, connectAccount, socials };
